import { IconType } from 'components/Icon';
import Section from 'components/Panel/Section';
import TextInput from 'components/Widget/Input/TextInput';
import { Style, Token } from 'dragonmouse-shared/style';
import { MenuItemAction } from 'menu/MenuItem';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showContextMenu } from 'redux/mode/actions';
import { displayViewOnlyModal } from 'redux/mode/util';
import * as Panel from '../../../styles';
import * as DS from '../styles';

interface TokenSetupProps {
	activeStyle: Style;
	updateCurrentStyle: (update: Partial<Style>) => void;
	viewOnly?: boolean;
}
const TokenSetup = ({ activeStyle, updateCurrentStyle, viewOnly }: TokenSetupProps) => {
	const dispatch = useDispatch();

	const onAddToken = () => {
		if (viewOnly) {
			displayViewOnlyModal();
			return;
		}
		if (!activeStyle) return;
		const token: Token = {
			title: '',
			value: '',
		};
		updateCurrentStyle({ tokens: [...(activeStyle.tokens || []), token] });
	};

	const onTokenContextMenu = (e: React.MouseEvent, index: number) => {
		if (!activeStyle) return;
		if (e.target instanceof HTMLElement) {
			dispatch(
				showContextMenu({
					point: { x: e.clientX, y: e.clientY },
					menuItems: [
						new MenuItemAction('Delete token', '', () => {
							updateCurrentStyle({
								tokens: activeStyle.tokens.filter((_, i) => i !== index),
							});
						}),
					],
				})
			);
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<Section
			label="Tokens"
			actions={[
				{
					tooltip: 'Add token',
					icon: IconType.ADD,
					onClick: onAddToken,
				},
			]}
		>
			{activeStyle?.tokens?.map((token, index) => (
				<DS.PropertyRow key={index} onContextMenu={(e) => onTokenContextMenu(e, index)}>
					<DS.PropertyLabel>
						<TextInput
							value={token.title}
							placeholder="e.g. 'Button height'"
							onChange={(e) => {
								if (viewOnly) {
									displayViewOnlyModal();
									return;
								}
								updateCurrentStyle({
									tokens: activeStyle.tokens.map((c, i) =>
										i === index ? { ...c, title: e.target.value } : c
									),
								});
							}}
						/>
					</DS.PropertyLabel>
					<DS.PropertySpacer />
					<DS.PropertyLabel>
						<TextInput
							value={token.value}
							placeholder="e.g. '48px'"
							onChange={(e) => {
								if (viewOnly) {
									displayViewOnlyModal();
									return;
								}
								updateCurrentStyle({
									tokens: activeStyle.tokens.map((c, i) =>
										i === index ? { ...c, value: e.target.value } : c
									),
								});
							}}
						/>
					</DS.PropertyLabel>
				</DS.PropertyRow>
			))}
			{activeStyle?.tokens?.length > 0 ? <Panel.Spacer /> : <Panel.HalfSpacer />}
		</Section>
	);
};

export default TokenSetup;
